import { Carousel as CarouselLib } from 'antd';
import styled from 'styled-components';

export const Carousel = styled(CarouselLib)`
  width: 400px;

  p {
    color: #C6C4C5;
    font-size: 50px;
    font-weight: 500;
    line-height: 124.4%;

    b {
      color: #4BFFA5;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;